import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { Overview } from './components/sections/Overview';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { PainPoints } from './components/sections/PainPoints';
import { Volumes } from './components/sections/Volumes';
import { StudyTools } from './components/sections/StudyTools';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { About } from './components/sections/About';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-ink" data-id="element-0" data-mp="3iiwg8rrbto4t">
      <MetaPixel data-id="element-1" data-mp="3mkrcviybbdc9" />
      <Hero data-id="element-2" data-mp="3mk84otygs3bf" />
      <main data-id="element-3" data-mp="3mjq27fl7ksv2">
        <Overview data-id="element-4" data-mp="3mjg8pi0yg3km" />
        <BeforeAfter data-id="element-5" data-mp="3rc9hqi3ghy2i" />
        <PainPoints data-id="element-6" data-mp="3rbzmaezn6ypf" />
        <Volumes data-id="element-7" data-mp="3rdkg22e4udm8" />
        <StudyTools data-id="element-8" data-mp="3rd19fhtxnbni" />
        <Bonuses data-id="element-9" data-mp="3relwynhtxubv" />
        <Offer data-id="element-10" data-mp="5opiv1o0k3w" />
        <Guarantee data-id="element-11" data-mp="6801qozk67w" />
        <Testimonials data-id="element-12" data-mp="4n7g6m8exco" />
        <About data-id="element-13" data-mp="82kl3wchwbg" />
        <FAQ data-id="element-14" data-mp="2zl3a7gleoy37" />
        <FinalCTA data-id="element-15" data-mp="2zld1r8m3ndb0" />
      </main>
      <Footer data-id="element-16" data-mp="2zmepodo7rua5" />
      <FloatingCTA data-id="element-17" data-mp="2zmo5x9jgin2n" />
      <PurchasePopup data-id="element-18" data-mp="2zn678kkz7rhf" />
    </div>;
}